import React from "react";
import "./TopPicks.css";
import { TOPPICKS_DATA as PicksData } from "../../utility/data/Data";
const TopPicks = () => {
  return (
    <div className="maxWidth topPicksContainer">
      <div>
      <div className="title">Top picks for you</div>
      <div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="64px"
          height="7px"
          display="block"
          fill="#25D366"
          viewBox="0 0 57 4"
          className="sc-64ptou-0 fRuWqJ"
        >
          <rect width="39" height="4" rx="2"></rect>
          <rect x="43" width="14" height="4" rx="2"></rect>
        </svg>
      </div>
      </div>
      <div className="maxWidth flex topPicksContainer">
          {PicksData.map((data) => {
            return (
              <div key={data.id} className="pickCard cursorPointer">
                <img
                  src={data.banner[`TopPicksBanner${data.id}`]}
                  alt={data.id}
                  className="pickCard"
                />
              </div>
            );
          })}
        </div>
    </div>
  );
};

export default TopPicks;
